/* =========================================================
   TOKI PARTNER DROP CAMPAIGNS
   EDIT THIS FILE TO ADD / REMOVE / SCHEDULE ADVERTISERS.
   ========================================================= */

window.TOKI_PARTNER_DROP_SETTINGS = {
  autoRotateMs: 6500,
  pauseWhenHovered: false,
  pauseWhenFocused: true,

  /* Paid plans never see Partner Drops. Tag matching is normalized. */
  hiddenForPlanTags: [
    "plan_wheel_plus",
    "plan_vortex_pro",
    "wheel_plus",
    "wheel plus",
    "vortex_pro",
    "vortex pro"
  ]
};

window.TOKI_PARTNER_DROP_CAMPAIGNS = [
  {
    id: "grit-goo-launch-2026",
    active: true,

    /* Leave blank for no date limit. ISO dates recommended. */
    startAt: "",
    endAt: "",

    /* Show this campaign anywhere a mount uses one of these placement names. */
    placements: ["wheel-pages", "snap-pages", "lab-pack-pages"],

    priority: 100,

    sponsorName: "Grit Goo",
    disclosure: "Sponsored",

    kicker: "Featured Partner",
    title: "Enter the Grit Goo Wasteland",
    text: "Dirty little marshmallow misfits. Scrap-built chaos. Meet the world of Grit Goo and step into a gloriously unhinged wasteland.",

    logoUrl: "https://cdn.shopify.com/s/files/1/0709/3675/6398/files/gritgoologosponsor.png?v=1783872691",
    bannerUrl: "https://cdn.shopify.com/s/files/1/0709/3675/6398/files/gritgoobannersponsor.png?v=1783882117",
    bannerAlt: "Grit Goo wasteland",

    ctaLabel: "Enter Grit Goo",
    ctaUrl: "https://gritgoo.com/",

    /* Campaign colors control the spotlight world without changing the engine. */
    theme: {
      bgA: "#090806",
      bgB: "#2c190f",
      accent: "#ff7a1a",
      accent2: "#9acb36",
      ink: "#fff1c7",
      muted: "rgba(255,241,199,.76)",
      glow: "rgba(255,122,26,.24)"
    }
  },

  {
    id: "spin-the-wheel-lab-advertise-2026",
    active: true,

    startAt: "",
    endAt: "",

    placements: ["wheel-pages", "snap-pages", "lab-pack-pages"],

    priority: 95,

    sponsorName: "Spin the Wheel Lab",
    disclosure: "Partner Opportunity",

    kicker: "Advertise With Us",
    title: "Put Your Brand In The Spin",
    text: "Create a curated Partner Drop or a full interactive sponsored wheel experience built to feel native, playful, and impossible to ignore.",

    logoUrl: "https://cdn.shopify.com/s/files/1/0709/3675/6398/files/stwllogopartnerdrops.png?v=1786565563",
    bannerUrl: "https://cdn.shopify.com/s/files/1/0709/3675/6398/files/goorosestudiosbanner.png?v=1786565550",
    bannerAlt: "Spin the Wheel Lab partner opportunities",

    ctaLabel: "Advertise With Us",
    ctaUrl: "https://spinthewheellab.com/pages/partners",

    theme: {
      bgA: "#171725",
      bgB: "#073C49",
      accent: "#20CDE8",
      accent2: "#6E4DFF",
      ink: "#F4E2BC",
      muted: "rgba(244,226,188,.76)",
      glow: "rgba(32,205,232,.14)"
    }
  },


  /*
  COPY THIS OBJECT FOR THE NEXT ADVERTISER:

  {
    id: "unique-campaign-id",
    active: true,
    startAt: "2026-08-01T00:00:00Z",
    endAt: "2026-09-01T00:00:00Z",
    placements: ["wheel-pages", "snap-pages"],
    priority: 90,

    sponsorName: "Brand Name",
    disclosure: "Sponsored",
    kicker: "Partner Drop",
    title: "Campaign headline",
    text: "One concise sentence that makes the click feel interesting.",

    logoUrl: "https://...",
    bannerUrl: "https://...",
    bannerAlt: "Brand campaign banner",

    ctaLabel: "Explore",
    ctaUrl: "https://...",

    theme: {
      bgA: "#140728",
      bgB: "#003049",
      accent: "#cc007e",
      accent2: "#11b7c8",
      ink: "#fff8ee",
      muted: "rgba(255,248,238,.72)",
      glow: "rgba(204,0,126,.20)"
    }
  }
  */
];
